/**
 * Escape one field for the DataTable toolbar CSV export.
 *
 * Excel, LibreOffice, and Google Sheets evaluate a quoted cell that starts
 * with `=`, `+`, `-`, `@`, tab, or CR (after optional leading whitespace).
 * A leading apostrophe makes those cells literal text.
 */
export function escapeCsv(input: unknown): string {
    let str = input == null ? "" : String(input);
    // Prefix formula-like values so spreadsheets treat them as text (CSV injection)
    if (/^\s*[=+\-@\t\r]/.test(str)) str = "'" + str;
    return '"' + str.replace(/"/g, '""') + '"';
}
